import React, { Component } from "react";
import "../css/OrgChartTree.css"; // External CSS file for better styling separation

export default class OrgChart extends Component {
  state = {
    treeData: {
      name: "Amit Verma",
      role: "Admin",
      children: [
        {
          name: "Rahul Bhatia",
          role: "Inventory Manager",
          children: [
            { name: "Nidhi Kapoor", role: "Inventory Checker" },
            { name: "Kunal Josh", role: "Warehouse Support" },
            { name: "Add New User", isAddButton: true },
          ],
        },
        {
          name: "Sneha Rao",
          role: "Support Executive",
          children: [{ name: "Add New User", isAddButton: true }],
        },
        {
          name: "Tamayy Sharma",
          role: "Project Lead",
          children: [
            { name: "Riya Mehta", role: "Support Agent" },
            { name: "Zeeshan Khan", role: "Support Agent" },
            { name: "Add New User", isAddButton: true },
          ],
        },
      ],
    },
  };

  renderNode = (node) => {
    return (
      <li>
        <div className={`node ${node.isAddButton ? "add-node" : ""}`}>
          <div className="node-content">
            <div className="circle">
              {node.isAddButton ? (
                <span className="plus">👤</span>
              ) : (
                <span className="user-icon">👤</span>
              )}
            </div>
            <div className="node-info">
              <strong style={{fontSize:'13px'}}>{node.name}</strong>
              {!node.isAddButton && <p style={{fontSize:'12px'}}>{node.role}</p>}
            </div>
          </div>
        </div>
        {node.children && (
          <ul>
            {node.children.map((child, index) => (
              <React.Fragment key={index}>
                {this.renderNode(child)}
              </React.Fragment>
            ))}
          </ul>
        )}
      </li>
    );
  };

  render() {
    return (
      <div className="org-chart-container">
        <div className="tree-view">
          <ul>{this.renderNode(this.state.treeData)}</ul>
        </div>
      </div>
    );
  }
}
